import React, { useEffect, useState } from "react";
import axios from "axios";
import authManager from "../../../utils/authManager";
import { useParams } from "react-router-dom";
import Layout from "../Layout";
import Pagination from "../../ui/Pagination";

const BASE_URL = "https://dhadakkamgarfilmunion.in/backend/assets-two/forms/";

const FormUrls = {
  "MEMBER SHIP APPLICATION FORM": "Membership_Form",
};

const ShowForm = () => {
  console.log(123);
  
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    limit: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(true);
  const { type } = useParams();

  const fetchFormData = async (page = 1) => {
    try {
      setLoading(true);
      const offset = (page - 1) * pagination.limit;

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}${FormUrls[type]}?limit=${pagination.limit}&offset=${offset}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authManager.getAccessToken()}`,
          },
        }
      );

      if (res.data?.response && Array.isArray(res.data.data)) {
        setData(res.data.data);
        const total = res.data.total || res.data.data.length || 0;
        const limit = res.data.limit || pagination.limit;

        setPagination({
          currentPage: page,
          totalPages: Math.ceil(total / limit),
          limit,
          total,
        });
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFormData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  // 🔹 Pagination handler
  const handlePageChange = (page) => {
    if (page !== pagination.currentPage && page > 0 && page <= pagination.totalPages) {
      fetchFormData(page);
    }
  };

  // 🔹 Render dynamic cells
  const renderCell = (key, value) => {
    if (value === null || value === undefined || value === "") return "-";

    // ✅ Handle arrays (like family_details)
    if (Array.isArray(value)) {
      if (typeof value[0] === "object") {
        return (
          <div className="space-y-1">
            {value.map((obj, idx) => (
              <div
                key={idx}
                className="bg-gray-50 border border-gray-200 rounded p-2 text-xs"
              >
                {Object.entries(obj).map(([k, v]) => (
                  <div key={k}>
                    <strong className="capitalize">
                      {k.replaceAll("_", " ")}:
                    </strong>{" "}
                    {v || "-"}
                  </div>
                ))}
              </div>
            ))}
          </div>
        );
      } else {
        return value.join(", ");
      }
    }

    // ✅ Detect image or file
    if (typeof value === "string") {
      const lower = value.toLowerCase();
      if (/\.(webp|jpg|jpeg|png|gif)$/i.test(lower)) {
        return (
          <a
            href={`${BASE_URL}${value}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            View
          </a>
        );
      } else if (/\.(pdf|doc|docx)$/i.test(lower)) {
        return (
          <a
            href={`${BASE_URL}${value}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            View File
          </a>
        );
      }
    }

    // ✅ Format dates
    if (key.toLowerCase().includes("date") && value) {
      return new Date(value).toLocaleDateString();
    }

    // ✅ Highlight status
    if (key === "status") {
      const color =
        value === "pending"
          ? "bg-yellow-100 text-yellow-700"
          : value === "approved"
          ? "bg-green-100 text-green-700"
          : "bg-red-100 text-red-700";
      return (
        <span
          className={`px-3 py-1 rounded-full text-xs font-semibold ${color}`}
        >
          {value}
        </span>
      );
    }

    // ✅ Default display
    return value?.toString() ?? "-";
  };

  if (loading)
    return <div className="text-center py-10 text-gray-500">Loading...</div>;

  if (!data.length)
    return <div className="text-center py-10 text-gray-500">No records found</div>;

  const columns = Object.keys(data[0]);

  return (
    <Layout>
      <div className="p-6">
        <h1 className="text-xl font-semibold mb-4 text-gray-800">{type}</h1>

        <div className="overflow-x-auto rounded-lg shadow-md">
          <table className="min-w-full border-collapse bg-white text-sm text-left text-gray-700">
            <thead className="bg-gray-100 text-gray-900">
              <tr>
                <th className="px-4 py-3 border-b">#</th>
                {columns.map((col) => (
                  <th key={col} className="px-4 py-3 border-b capitalize">
                    {col.replaceAll("_", " ")}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, i) => (
                <tr
                  key={row.id || i}
                  className="border-b hover:bg-gray-50 transition duration-150"
                >
                  <td className="px-4 py-3">
                    {(pagination.currentPage - 1) * pagination.limit + i + 1}
                  </td>
                  {columns.map((col) => (
                    <td key={col} className="px-4 py-3">
                      {renderCell(col, row[col])}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* ✅ Global Pagination at bottom */}
        <Pagination
          pagination={pagination}
          handlePageChange={handlePageChange}
          loading={loading}
        />
      </div>
    </Layout>
  );
};

export default ShowForm;
